import { SVGProps, useEffect } from "react"
import { useRouter } from "next/router"
import { gsap } from "gsap"

// import { MintVariant } from "@hfc/shared/utils/blockchain/polygon/mintFarmers"
// import { roomOffsetX, roomOffsetY } from "layout/Room"

import MetaverseSVG from "public/assets/SVG/room-map-labels.svg"

const useLocationAnimation = () => {
	const animatedObjects = [
		{
			id: 1,
			label: "room-map-labels_svg__label-the-barn",
			location: "room-map-labels_svg__the-farm",
			path: "/the-farm",
		},
		{
			id: 2,
			label: "room-map-labels_svg__label-tractor",
			location: "room-map-labels_svg__Yellow_Tractor",
			path: "/tractor",
		},
		{
			id: 3,
			label: "room-map-labels_svg__label-club-house",
			location: "room-map-labels_svg__country-club",
			path: "/club-house",
		},
		{
			id: 4,
			label: "room-map-labels_svg__label-wedding-area",
			location: "room-map-labels_svg__Wedding",
			path: "/wedding",
		},
		{
			id: 5,
			label: "room-map-labels_svg__label-wheel-of-fortune",
			location: "room-map-labels_svg__Wheel",
			path: "/wheel-of-fortune",
		},
		{
			id: 6,
			label: "room-map-labels_svg__label-airdrops",
			location: "room-map-labels_svg__Wheel",
			path: "claim-airdrop",
		},
	]

	animatedObjects.map(({ label, location, path }) => {
		const router = useRouter()
		useEffect(() => {
			const element = document.getElementById(label)
			let tween: gsap.core.Tween

			if (element) {
				// Animate farm
				tween = gsap.to(`#${label}`, {
					duration: 0.8,
					// ease: "elastic",
					repeat: Infinity,
					yoyo: true,
					y: -16,
				})
			}

			return () => {
				if (tween) tween.kill()
			}
		}, [])

		useEffect(() => {
			const labelDom = document.getElementById(label)
			const locationDom = document.getElementById(location)

			labelDom.addEventListener("click", () => {
				router.push(path)
			})
			locationDom.addEventListener("click", () => {
				router.push(path)
			})
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [])
	})
}

const useClouds = () => {
	const id = "room-map-labels_svg__Clouds"
	useEffect(() => {
		const element = document.getElementById(id)
		let tween: gsap.core.Tween

		if (element) {
			// Animate farm
			tween = gsap.to(`#${id}`, {
				duration: 3,
				repeat: Infinity,
				yoyo: true,
				x: 50,
			})
		}

		return () => {
			if (tween) tween.kill()
		}
	}, [])
}

const useFish = () => {
	const id = "room-map-labels_svg__Fish"

	useEffect(() => {
		const element = document.getElementById(id)
		let tween: gsap.core.Tween

		if (element) {
			// Animate farm
			tween = gsap.to(`#${id}`, {
				rotation: -50,
				y: -75,
				x: -500,
				duration: 15,
				ease: "easeOut",
			})
		}

		return () => {
			if (tween) tween.kill()
		}
	}, [])
}

const useRichlistLocation = () => {
	const id = "room-map-labels_svg__Green-Tractor"
	const router = useRouter()
	// useEffect(() => {
	// 	const element = document.getElementById(id)
	// 	let tween: gsap.core.Tween

	// 	if (element) {
	// 		// Animate farm
	// 		tween = gsap.to(`#${id}`, {
	// 			duration: 20,
	// 			// ease: "elastic",
	// 			repeat: Infinity,
	// 			yoyo: true,
	// 			x: -900,
	// 			y: 525,
	// 		})
	// 	}

	// 	return () => {
	// 		if (tween) tween.kill()
	// 	}
	// }, [])

	useEffect(() => {
		const farm = document.getElementById(id)

		farm.addEventListener("click", () => {
			router.push("/profiles")
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])
}

const Metaverse = (props: SVGProps<SVGSVGElement>) => {
	useLocationAnimation()
	useFish()
	useRichlistLocation()
	useClouds()

	return (
		<>
			<MetaverseSVG
				className="absolute inset-0 z-0 min-h-screen h-max"
				{...props}
			/>
		</>
	)
}

export default Metaverse
